// extracted by mini-css-extract-plugin
module.exports = {"root":"EventList_root__x9FFt","filter":"EventList_filter____sRp","text":"EventList_text__erEEd","events":"EventList_events__5ePI0"};